/* eslint-disable @angular-eslint/prefer-standalone */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-vendor-performance',
  templateUrl: './vendor-performance.component.html',
  styleUrls: ['./vendor-performance.component.scss'],
  standalone: false
})
export class VendorPerformanceComponent implements OnInit {
  public sustainmentId: string;
  public companyName: string;
  public alias: string;

  public constructor(private route: ActivatedRoute) {}

  public ngOnInit(): void {
    // get sustainmentId from path
    this.route.params.subscribe((params) => {
      this.sustainmentId = params['sustainmentId'];
      this.companyName = params['companyName'];
      this.alias = params['alias'];
    });
  }
}
